import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import swal from 'sweetalert';
import moment from "moment";
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import { PeriodSelectionWithCustom, DisplaySearchCriteria } from "../../../../components/TapUi/index";
import TapSelect from "../../../../components/ui/TapSelect";
import { IAM_API_BASE_URL_2, IAM_API_BASE_URL_3 } from '../../../../services/TapApiUrls';
import TapIcon from '../../../../services/TapIcon';
import TapHelper from '../../../../services/TapHelper';
import InputAssetSearch from '../../../includes/ui/InputAssetSearch';
import DateService from '../../../../services/DateService';
import DownloadFile from "../../../../services/DownloadFile";
import ApplicationLayout from "../../../../layouts/ApplicationLayout";
import PageHeader from '../../../includes/PageHeader';
import { authLoginAndGetJWTToken } from '../../../../store/actions/OmniComm/OmniCommAuthAction';
import { toast } from 'react-toastify';
import { apiRunWithAxios } from './APIRunWithAxios';
import api from '../../../../services/api';

const AssetStatisticDataReport = (props) => {
    const dispatch               =    useDispatch();
    // const setting                =    useSelector(state => state.app.setting);
    const access_token           =    useSelector(state => state.auth.access_token);
    const all_periods            =    useSelector(state => [...(state.app?.all_periods || []), { key: 'custom', display: 'Custom Date Range' }]);
    const { data }              =    useSelector(state => state.omniAuthLoginReducer);
    const reportListing         = useSelector(state => state.app.report_listing ? state.app.report_listing : []);
    const user_sites            =   useSelector(state => state.app.user_sites ? state.app.user_sites : []);
    const asset_type            =   useSelector(state => state.app.asset_type ? state.app.asset_type : []);
    const reportUrl             =  IAM_API_BASE_URL_2 + '/report/iot_statistic';

    const [searchedAssets, setSearchedAssets]           =   useState([]);
    const [listingData, setListingData]                 =   useState({
        loading: false,
        show: false,
    });
    const [reportDetail, setreportDetail]               =   useState(null);
    const [reportDownloading , setReportDownloading]    =   useState(false)
    const [downloadReportBtn , setDownloadReportBtn]    =   useState(false)

    let reportKey                   =   'asset_statistic_report';
    const [formData, setFormData] = useState({
                show                        :   true,
                loading                     :   false,
                downloading                 :   false,
                search_asset_ids            :   [],
                date_range                  :   '',
                date_range_start            :   '',
                date_range_end              :   '',
                all_periods                 :   [],
                vechile_device_ids          :   [],
                asset_data                  :   [],
                search_asset_type           :   [],
                search_site                 :   [],
                sites                       :   user_sites.map((s) => {
                    return { value: s.id, label: `${s.site_name} (${s.site_code})` }
                }),
                asset_types                 :   asset_type.map((s) => { return { value: s.id, label: s.     asset_type_name } }),
                periods: [...all_periods, { key: 'custom', display: 'Custom Date Range' }],
    });
    const [searchedElems, setSearchedElems]     =   useState([]);
    const [vechileData, setVechileData]         =   useState([]);
    const [assetAllData, setAllAssetData]       =   useState([]);
    const [allAssetIds , setAllAssetIds]        =   useState([]);

    const formDataLabel = {
        search_asset_ids: 'Assets : ',
        date_range: 'Period : ',
        search_asset_type: 'Asset Type : ',
        search_site: 'Site : ',
    };
    useEffect(() => {
        setreportDetail(reportListing.find(d => d.key == reportKey));
    }, [reportListing]);
    useEffect(() => {
        initializeReport();
    }, []);

    useEffect(() => {
        if (
            data?.jwt &&
            formData.date_range_start &&
            formData.date_range_end &&
            allAssetIds.length > 0
        ) {
            loadListingData();
        }
    }, [data]);

    const initializeReport = () => {
        setFormData(prev => ({
            ...prev,
            all_periods: all_periods,
            show: true
        }));
    };

    const toggleFilterForm = () => {
        setFormData(prev => ({ ...prev, show: !prev.show }));
        document.getElementById('pageTbl')?.scroll({ top: 0, behavior: 'smooth' });
    };

    const closeReport = () => {
        props.history.push('/report');
    };

    const submitSearchFormHandler = (e) => {
        e.preventDefault();
        const searchedElems = [];
        Object.keys(formDataLabel).forEach(key => {
            const value = formData[key];
            if (value && (Array.isArray(value) ? value.length > 0 : value.toString().length > 0)) {
                let displayValue = value;
                if (key === 'search_asset_ids') {
                    displayValue = searchedAssets.map(s => s.display_label).join(', ');
                }  else if (key == 'date_range') {
                    let start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
                    let end_range = moment(formData.date_range_end).format('DD-MMM-YYYY')
                    let display_custom = `Custom Date Range (${start_range} - ${end_range})`
                    displayValue = all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                }else if (key == 'search_asset_type') {
                    displayValue = formData.asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }else if (key == 'search_site') {
                    // displayValue = formData.sites.find(s => formData.search_site == s.value)?.label;
                    displayValue = formData.sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if (displayValue) {
                    searchedElems.push(`${formDataLabel[key]}<b>${displayValue}</b>`);
                }
            }
        });

        setSearchedElems(searchedElems);
        setFormData(prev => ({ ...prev, show: false }));
        loadListingData();
    };

    const loadListingData = (action = 'data') => {
        setReportDownloading(true)
        if(action == 'data') {
            setListingData(prev => ({
                ...prev,
                loading: true,
                show: true,
            }));
        }
        const startOfDay = Math.floor(new Date(formData.date_range_start + " 00:00:00").getTime() / 1000);
        const endOfDay = Math.floor(new Date(formData.date_range_end + " 23:59:59").getTime() / 1000);

        let params = {
            timeBegin: startOfDay,
            timeEnd: endOfDay,
            action,
              ...TapHelper.pick(formData, ['date_range', 'date_range_start', 'date_range_end', 'search_asset_type', 'search_site', 'search_asset_ids'])
        }
        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, {}, (response) => {
            if(action === 'download') {
                DownloadFile.file(response.data.file_path)
            }else {    
                const resData       =   response?.data?.iot_data?.data?.vehicleDataList;
                setAllAssetData(response?.data?.asset_profiles);
                setVechileData(resData ? resData : []);
                setDownloadReportBtn(true);
                setListingData({
                    loading: false,
                    show: true,
                });
            }
        }).then(() => {
            setReportDownloading(false);
            setListingData({
                loading: false,
                show: true,
            });
        });
    }

    const topRightHeaderJsx = () => (
        <div className="text-end mt-1">
            <button type="button" onClick={toggleFilterForm} className="btn btn-secondary">
                Change Filter
            </button>
            {downloadReportBtn ?
                <button type="button" onClick={() => loadListingData('download')} disabled={reportDownloading} className="btn btn-primary">
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {reportDownloading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />) : null}
                </button>
                : null} 
            <button type="button" className="btn btn-secondary ms-1" onClick={closeReport}>
                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
            </button>
        </div>
    );

    const filterFormJsx = () => (
        <form onSubmit={submitSearchFormHandler} className="p-3 filter_form">
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label col-form-label-sm text-end ">Asset </label>
                <div className="col-sm-8">
                    <InputAssetSearch
                        changeEvent={(selectedOption) => {
                            const selectedAssets = selectedOption || [];
                            const deviceIds = selectedAssets
                                .map(a => a.asset.iot_device?.manufacturer_device_id);

                            setSearchedAssets(selectedAssets);

                            setFormData(prev => ({
                                ...prev,
                                search_asset_ids: selectedAssets.map(a => a.value),
                                vechile_device_ids: selectedAssets.map(a => a.asset.iot_device?.manufacturer_device_id).filter(d => d)
                            }));
                        }}
                        isMulti={true}
                        menuPlacement="bottom"
                        value={searchedAssets.map(a => ({ ...a, label: a.display_label }))}
                        onlyIotAsset="Y"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.asset_types}
                        changeEvent={o => setFormData(d => ({ ...d, search_asset_type: o.map(e => e.value) }))}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.asset_types.filter(s => formData.search_asset_type.includes(s.value))}
                        placeholder="Select Asset Type"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">
                    Site
                </label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.sites}
                        changeEvent={e => setFormData(d => ({ ...d, search_site: e.map(s => s.value) }))}
                        isSearchable={true}
                        isClearable={true}
                        value={formData.sites.filter(s => formData.search_site.includes(s.value))}
                        isMulti={true}
                        placeholder="Select Site"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end require">Select Period </label>
                <div className="col-sm-8">
                    <PeriodSelectionWithCustom
                        periods={formData.all_periods}
                        value={formData.date_range}
                        startDate={formData.date_range_start}
                        endDate={formData.date_range_end}
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData(prev => ({
                                ...prev,
                                date_range: period,
                                date_range_start: startDate || '',
                                date_range_end: endDate || ''
                            }));
                        }}
                        menuPlacement="bottom"
                        required
                    />
                </div>
            </div>

            <div className="row">
                <div className="pb-3 col-9 text-end">
                    <button type="submit" disabled={listingData.loading} className="btn btn-primary px-4">
                        Show Report{listingData.loading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
                    </button>
                </div>
                <hr />
            </div>
        </form>
    );

    const reportListingJsx = () => {
        
        return (
            <>
                <div>
                    <DisplaySearchCriteria searchedElems={searchedElems} />
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover bg-white mt-1">
                        <thead className="align-middle table-secondary" >
                            <tr>
                                <th className="text-center" style={{ width: "5%" }}>S.No</th>
                                <th className='text-center' style={{ width: "10%" }}>Asset Name</th>
                                <th className='text-center' style={{ width: "8%" }}>Site</th>
                                <th className='text-center' style={{ width: "8%" }}>Engine operation time</th>
                                <th className="text-center" style={{ width: "8%" }}>Time with the engine switched off</th>
                                <th className="text-center" style={{ width: "7%" }}>Total Km Running</th>
                                <th className="text-center" style={{ width: "7%" }}>Initial volume</th>
                                <th className='text-center' style={{ width: "7%" }}>Refueling volume</th>
                                <th className='text-center' style={{ width: "7%" }}>Draining volume</th>
                                <th className="text-center" style={{ width: "7%" }}>Final volume</th>
                                <th className='text-center' style={{ width: "7%" }}>Actual consumption</th>
                                <th className='text-center' style={{ width: "8%" }}>Actual mileage per 1 l</th>
                                {/* <th className='text-center' style={{ width: "9%" }}>Actual fuel consumption per 1 hour of engine operation</th> */}
                                <th className='text-center' style={{ width: "9%" }}>Actual fuel consumption per engine hour</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listingData.loading
                                ? <tr><td className="text-center" colSpan="14"><Loader /></td></tr>
                                : (vechileData.length > 0
                                    ?
                                    vechileData.map((item, index) => {
                                        let asset = assetAllData.find(d => d.manufacturer_device_id === item.vehicleID)
                                        return (
                                            <tr key={item.asset_id || index}>
                                            <td className='text-center'>{index + 1}</td>
                                            <td className='text-center'>
                                                {
                                                    asset?.name
                                                }
                                            </td>
                                            <td className='text-center'>
                                                {

                                                    asset?.site_name
                                                }
                                            </td>
                                            <td className='text-center'>
                                                {DateService.formatSecondsToTime(item?.mw?.worked)}
                                            </td>
                                            <td className='text-center'>
                                                {DateService.formatSecondsToTime(item?.mw?.layUp)}
                                            </td>
                                            
                                            <td className='text-center'>
                                                {item?.mw?.mileage ? TapHelper.numberFormatter(item?.mw.mileage) : ''}
                                            </td>
                                            <td className='text-center'>
                                                {item?.fuel ? item?.fuel?.startVolume/10 : ''}
                                            </td>
                                            <td className='text-center'>
                                                {item?.fuel ? item?.fuel?.refuelling/10 : ''}
                                            </td>
                                            <td className='text-center'>
                                                {item?.fuel ? item?.fuel?.draining/10 : ''}
                                            </td>
                                            <td className='text-center'>
                                                {item?.fuel ? item?.fuel?.endVolume/10 : ''}
                                            </td>
                                            <td className='text-center'>
                                                {item?.fuel ? item?.fuel?.fuelConsumption/10 : ''}
                                            </td>
                                            <td className='text-center'>{(item?.fuel.fuelConsumption/10) !== 0 && item?.mw?.mileage ? TapHelper.numberFormatter(((item?.mw.mileage) / (item?.fuel.fuelConsumption/10))) : ''}</td>
                                            {/* <td className='text-center'>{item?.fuel?.fuelConsMH ? TapHelper.numberFormatter((item?.fuel.fuelConsMH/10), 1) : ''}</td> */}
                                            <td className='text-center'>{item?.fuel?.fuelConsPerMotorhour ? TapHelper.numberFormatter((item?.fuel.fuelConsPerMotorhour/10), 1) : ''}</td>
                                        </tr>
                                        )
                                    })
                                    : (<tr><td colSpan="14" className="text-center">No Records</td></tr>))}
                        </tbody>
                    </table>
                </div>
            </>
        );
    };

    return (
        <ApplicationLayout>
            <PageHeader title={reportDetail?.name} name={reportDetail?.name} rightTopHeadingJsx={topRightHeaderJsx()} />
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {filterFormJsx()}
                        </div>
                        {listingData.show && reportListingJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default AssetStatisticDataReport;